import React from 'react'

import styled, { css } from 'styled-components'

import { ComponentStyleSheet } from '@nexiahome/ui-common/themes'
import { ButtonTheme } from '@nexiahome/ui-common/components/primitives/buttons'
import Spinner from 'components/Spinner'

import { color } from 'styles/colors'

export const sideNavbarCollapsedWidth = 65
export const sideNavbarExpandedWidth = 300

export const screenWidthBreakpoints = {
  minMedium: 575 + sideNavbarCollapsedWidth,
  maxMedium: 1024 + sideNavbarExpandedWidth,
  maxLarge: 1400 + sideNavbarExpandedWidth,

  devicePanelHeaderShortVersionBreakpoint: 1090,
  homeownerAlertedShortVersionBreakpoint: 1330
}

export const alertsAndRthPanelLongVersionTitleWidth = 260

export const screenSize = {
  small: `(max-width: ${screenWidthBreakpoints.minMedium - 1}px)`,
  mediumOnly: `(min-width: ${screenWidthBreakpoints.minMedium}px) and (max-width: ${screenWidthBreakpoints.maxMedium}px)`,
  medium: `(max-width: ${screenWidthBreakpoints.maxMedium}px)`,
  large: `(max-width: ${screenWidthBreakpoints.maxLarge}px)`,

  isSmall: () => window.innerWidth < screenWidthBreakpoints.minMedium,
  isMedium: () => window.innerWidth >= screenWidthBreakpoints.minMedium && window.innerWidth <= screenWidthBreakpoints.maxMedium,
  isLarge: () => window.innerWidth > screenWidthBreakpoints.maxMedium
}

export const ButtonContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['noBorder', 'variant'].includes(prop)
})<{
  noBorder?: boolean;
  variant?: 'submit' | 'submit-delete';
}>`
  height: 60px;
  padding-top: 20px;
  margin-top: 30px;
  ${({ noBorder = false }) => !noBorder && `border-top: 1px solid ${color('border')};`}
  display: flex;
  justify-content: ${({ variant }) => variant === 'submit-delete' ? 'space-between' : 'flex-end'};

  button:not(:first-of-type) {
    margin-left: 10px;
  }
`

export const EmptyListMessage = styled.div`
  margin-top: 3em;
  text-align: center;
  color: ${color('watermarkDescription')};
  font-size: 3em;
`

export const NoData = styled.div`
  width: fit-content;
  margin: auto;
  padding: 6em 0 10em 0;
  text-align: center;

  h1 {
    font-size: 3em;
    color: ${color('watermarkTitle')};
  }

  h2 {
    color: ${color('watermarkDescription')};
  }
`

export const SinglePanePage = styled.div`
  background-color: ${color('paneBackground')};
  padding: 20px;
  margin: 10px;
  border-radius: 4px;
  flex: 1;

  @media ${screenSize.small} {
    margin: 0;
    padding: 10px;
    border-radius: 0;
  }
`

export const LoadingSinglePanePage = () => <SinglePanePage><Spinner variant="page" /></SinglePanePage>

export const PageHeader = styled.div`
  padding: 60px 20px 20px 20px;
  background-color: ${color('paneBackground')};
`

// TODO: consider just styling h1 the way want it instead of having this component
export const PageTitle = styled.h1`
  font-size: 28pt;
  font-weight: bold;
  color: ${color('pageTitle')};
  margin-top: 0;
  text-wrap: nowrap;
  text-transform: uppercase;

  @media ${screenSize.small} {
    display: none;
    font-size: 16pt;
  }
`

// TODO: consider just styling h2 the way want it instead of having this component
export const PanelTitle = styled.h2`
  font-size: 14pt;
  font-family: inter.bold;
  color: ${color('cardTitle')};
  text-transform: unset;
  margin-bottom: 10px;
`

export const focusOutline = ({ executable = true, focusOutlineValueOnly = false } = {}) => {
  let outlineValue

  if (executable) {
    outlineValue = `2px solid ${color('executableFocusOutline')}`
  } else {
    outlineValue = `1px dashed ${color('nonExecutableFocusOutline')}`
  }

  if (focusOutlineValueOnly) {
    return outlineValue
  }

  return css`
    &:focus {
      outline-offset: -2px;
      outline: ${outlineValue};
    }
  `
}

export const PanelHeaderSecondaryButton: ComponentStyleSheet<ButtonTheme> = {
  button: {
    height: 28,
    marginRight: 3,
    backgroundColor: color('paneBackground')
  }
}

export const PanelHeaderPrimaryButton: ComponentStyleSheet<ButtonTheme> = {
  button: {
    marginRight: 3,
    height: 28
  }
}

export const Circle = styled.div.withConfig({
  shouldForwardProp: (prop) => !['color'].includes(prop)
})<{ color: string }>`
  margin: auto 5px auto 0px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  display: inline-block;
`
